export default {
  namespaced: true,
  state: {
    symbolName: ''
  },
  mutations: {
    setSymbolName (state, payload) {
      state.symbolName = payload
    }
  }
}
